module.exports = __webpack_public_path__ + "img/02.95b4e9ca.jpg";